import { createSelector } from 'reselect';

const getProvidersBranch = (state) => state.providers;

export const getProvidersById = createSelector(
  getProvidersBranch,
  ({ byId }) => byId
);

const getProvidersStatus = createSelector(
  getProvidersBranch,
  ({ status }) => status
);

export const getProvidersIsLoading = createSelector(
  getProvidersStatus,
  ({ isLoading }) => isLoading
);

export const getProvidersError = createSelector(
  getProvidersStatus,
  ({ error }) => error
);
